module.exports = require("lamejs");